import React, {Component} from 'react';
import {HeadingSmall, ParagraphLarge} from 'baseui/typography';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import * as ROUTES from '../../Routes';
import {Button, KIND, SIZE} from 'baseui/button';
import WinAppStoreBadge from '../../images/platforms/windows/badge_app_store';

const centerProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

class Microsoft extends Component {
    renderDetails = () => {
        return <FlexGrid>
            <FlexGridItem>
                <FlexGrid backgroundColor={'primaryB'} style={{padding: '20px'}}>
                    <FlexGridItem><HeadingSmall margin={0}>EncLock Windows</HeadingSmall></FlexGridItem>
                    <FlexGridItem>
                        <ParagraphLarge>
                        The latest version of EncLock for Windows is now available on the Microsoft Store! With multiple updates and enhancements, this new version brings improved security features and a more seamless user experience. EncLock helps you protect sensitive files, passwords, notes, credit cards, and more. It's time to experience the latest advancements in data security on your Windows machine.
                        </ParagraphLarge>
                    <ParagraphLarge>Download EncLock for Windows today and keep your data safe with just a few clicks.</ParagraphLarge>
                    </FlexGridItem>
                    <FlexGridItem {...centerProps}>
                        <Button href={ROUTES.ENCLOCK_MICROSOFT_INSTALL} $as={'a'} target={"_blank"} size={SIZE.large} kind={KIND.tertiary}>{WinAppStoreBadge()}</Button>
                    </FlexGridItem>
                </FlexGrid>
            </FlexGridItem>
        </FlexGrid>
    };

    render = () => {
        return <div>
            {this.renderDetails()}
        </div>
    };
}

export default Microsoft;